import { render, staticRenderFns } from "./zd.vue?vue&type=template&id=130a5f82&scoped=true"
import script from "./zd.vue?vue&type=script&lang=js"
export * from "./zd.vue?vue&type=script&lang=js"
import style0 from "./zd.vue?vue&type=style&index=0&id=130a5f82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a5f82",
  null
  
)

export default component.exports